export const MIN_OPTION_COUNT = 2;
